import { render, staticRenderFns } from "./NewCustomerAddedModal.vue?vue&type=template&id=54dc94d2&scoped=true&"
import script from "./NewCustomerAddedModal.vue?vue&type=script&lang=js&"
export * from "./NewCustomerAddedModal.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerAddedModal.vue?vue&type=style&index=0&id=54dc94d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc94d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VRow,VToolbar,VToolbarTitle})
